




import Vue from 'vue'

/**
 * plain simple text input with the added keyboard shortcut to focus
 */
export default Vue.extend({
  props: {
    //default value for v-model
    value: {
      type: String
    },
    //customize shortcut key by passing this prop
    shortcutKey: {
      type: String,
      default: 'k'
    }
  },
  computed: {
    title(): string {
      return 'Command+' + this.shortcutKey.toUpperCase() + ' to focus'
    }
  },
  mounted() {
    document.addEventListener('keydown', this.focusSearch)
  },
  destroyed() {
    document.removeEventListener('keydown', this.focusSearch)
  },
  methods: {
    focusSearch(e: KeyboardEvent) {
      //bind Command+K to focus on this input
      if (e.metaKey && e.key === this.shortcutKey) {
        const input = this.$el as HTMLInputElement
        input.focus()
        input.select()
      }
    }
  }
})
